import {
  post_request,
  get_request_export
} from '../axiosFun'

//查询调度任务列表
export const get_dispatch_task_list = (params) => {
  params = {
    row: {
      plan_id: window.localStorage.getItem("plan_task"),
      vin:params.vin,
      task_name: params.task_name,
      creator: params.userId,
      create_time: params.create_time,
      task_start_place_id: params.task_start_place_id,
      task_end_place_id: params.task_end_place_id,
      head: params.head,
      escort_person: params.escortPerson,
      status: params.status,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/schedule_task/list", params)
}
//查询调度任务列表
export const get_dispatch_get_car_task = (params) => {
  params = {
    row: {
      vin:params.vin,
      task_name: params.task_name,
      creator: params.userId,
      create_time: params.create_time,
      task_start_place_id: params.task_start_place_id,
      task_end_place_id: params.task_end_place_id,
      head: params.head,
      escort_person: params.escortPerson,
      status: params.status,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/schedule_task/get_car_task", params)
}
//添加   任务车辆列表
export const get_taskCar_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/schedule/car_list", params)
}
//添加   计划负责人列表
export const get_planHead_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/schedule/user_list", params)
}
//添加   地点列表
export const get_cloudPlatformAreaSummaryNoParent_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/projectOperatingLog/cloudPlatformAreaSummaryNoParent", params)
}
//添加调度任务
export const get_dispatch_task_add = (params) => {
  params = {
    row: {
      plan_id: window.localStorage.getItem("plan_task"),
      vin: params.vin,
      task_name: params.task_name,
      start_place_id: params.startPlaceId,
      end_place_id: params.endPlaceId,
      head: params.head,
      escort_person: params.escortPerson,
      task_start_time: params.time_upend[0],
      task_end_time: params.time_upend[1],
    }
  }
  return post_request("/web/schedule_task/add", params)
}
//获取单条调度任务
export const get_dispatch_task_one = (params) => {
  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/schedule_task/get_one", params)
}
//编辑调度任务
export const get_dispatch_task_edit = (params) => {
  params = {
    row: {
      id: params.id,
      vin: params.vin,
      task_name: params.taskName,
      start_place_id: params.startPlaceId,
      end_place_id: params.endPlaceId,
      head: params.head,
      escort_person: params.escortPerson,
      task_start_time: params.time_upend[0],
      task_end_time: params.time_upend[1],
    }
  }
  return post_request("/web/schedule_task/update", params)
}
//删除调度任务
export const get_dispatch_task_del = (params) => {
  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/schedule_task/delete", params)
}
//撤销调度任务
export const get_dispatch_task_undo = (params) => {
  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/schedule_task/undo", params)
}
//导出一个或多个故障日志
export const get_export_dispatch_task = (params) => {
  params = {
    row: {
      ids: params
    }
  }
  return get_request_export("/web/schedule_task/export", params)
}



// WEBPACK FOOTER //
// ./src/api/dispatch/dispatch_task.js